//
// ChatMessageEmptyControls - Empty placeholder for chat message controls
// Provides consistent spacing where controls would normally appear
//

import classNames from 'classnames';
import PropTypes from 'prop-types';

function ChatMessageEmptyControls({
  myMessage,
}) {
  return (
    <div
      className={classNames(
        'w-14 flex flex-row justify-start items-center content-start flex-wrap mr-1 min-h-12',
        {
          'order-1 mr-1 ml-0': myMessage,
          'order-3 mr-0 ml-1': !myMessage,
        },
      )}
    />
  );
}

ChatMessageEmptyControls.propTypes = {
  myMessage: PropTypes.bool,
};

export default ChatMessageEmptyControls;
